import { Box, Checkbox, FormControlLabel } from "@mui/material";
import "./checkbox.css";

function CheckboxRb({
  className = "",
  classes = "",
  BD,
  BrandKeyword,
  SPKeyword,
  handleChangeNow,
  handleChange,
  onChange,
  checked,
  defaultChecked,
  disabled,
  label,
  id,
  name,
  value,
  title,
  inputLabelClass,
  index,
  multiselect,
}) {
  const changeHandler = BrandKeyword
    ? handleChangeNow
    : SPKeyword
    ? handleChange
    : onChange;
  const isControlled = checked !== undefined;
  const isChild = className.includes("child");
  const defaultCheckedValue =
    index === 1 || index === 2 ? true : defaultChecked;

  const checkbox = (
    <Checkbox
      id={id}
      name={name}
      value={value}
      size={BD ? "medium" : "small"}
      color="primary"
      checked={isControlled ? checked : undefined}
      defaultChecked={!isControlled ? defaultCheckedValue : undefined}
      onChange={changeHandler}
      disabled={disabled}
      className={className || undefined}
      sx={{ p: 0.5 }}
    />
  );

  const checkboxWithHover = isChild ? (
    checkbox
  ) : (
    <Box className={`checkbox-rb-hover-wrap ${classes}`.trim()}>
      {checkbox}
    </Box>
  );

  if (label !== undefined && label !== null && label !== "") {
    if (multiselect) {
      return (
        <Box className="checkbox-rb-container" title={title ?? ""}>
          <Box className="main-container-cb">
            {checkboxWithHover}
            <Box className="innput-label-cb">
              <Box
                component="label"
                htmlFor={id}
                className={inputLabelClass || undefined}
                sx={{ m: 0, cursor: "pointer" }}
              >
                {label}
              </Box>
            </Box>
          </Box>
        </Box>
      );
    }

    return (
      <Box
        className="checkbox-rb-container"
        title={title ?? ""}
        sx={{ display: "flex", alignItems: "center" }}
      >
        <FormControlLabel
          control={checkboxWithHover}
          label={label}
          slotProps={{
            typography: {
              className: inputLabelClass || undefined,
            },
          }}
          sx={{ m: 0, alignItems: "center", gap: 0.5 }}
        />
      </Box>
    );
  }

  return (
    <Box
      className="checkbox-rb-container"
      title={title ?? ""}
      sx={{ display: "inline-flex", alignItems: "center" }}
    >
      {checkboxWithHover}
    </Box>
  );
}

export default CheckboxRb;
